module.exports = __webpack_public_path__ + "media/landing_page/instacart-goodwillsf-lockup-dc6dff64.svg";